import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Injectable } from '@angular/core'
import { mergeMap } from 'rxjs/operators'
import { Observable, of } from 'rxjs'
import { UnitOfMeasureService } from '../services/unit-of-measure.service'

export interface ResolveParams {
    unitOfMeasureOptions: Map<string, string>
}

@Injectable()
export class ComponentTypeResolver {
    constructor(private unitOfMeasureService: UnitOfMeasureService) {
        //
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ResolveParams> {
        return this.unitOfMeasureService.getAll().pipe(
            mergeMap(unitOfMeasure => {
                const unitOfMeasureOptions = new Map<string, string>()

                unitOfMeasure.map(item => {
                    unitOfMeasureOptions.set(
                        item.key?.toLowerCase(),
                        item.description ? item.key + ' - ' + item.description : item.key
                    )
                })
                return of({ unitOfMeasureOptions })
            })
        )
    }
}
